<ng-content *ngIf="!!content?.children?.length; else placeholder"></ng-content>
<ng-template #placeholder>
  <span contenteditable="false" class="placeholder">{{ content.displayPlaceholder }}</span>
</ng-template>
